export default __webpack_public_path__ + "static/media/lock-white.7a574ea3.svg";